import React, { useEffect, useState } from "react";
import styles from "./header.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ForwardArrowIcon, HideMenuIcon, UserIcon } from "../../svg";
import { Popover } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getProfile, setLogOut } from "../redux/userSlice";
import { getNotification } from "../redux/notificationSlice";
import { AffiliategetProfile, setLogOut as affiliateSetLogOut } from "../redux/affiliateSlice";
import Toastify from "../helper/Toastify";
import { normalizeStoredToken } from "../helper/authSession";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname.split("/")[1];
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const affiliateState = useSelector((state) => state.affiliate);
  const [path, setPath] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileModal, setProfileModal] = useState(null);
  const [profileKind, setProfileKind] = useState(null);
  const token = normalizeStoredToken(localStorage.getItem("token"));
  const affiliateToken = normalizeStoredToken(localStorage.getItem("affiliatetoken"));

  const studentSessionOk =
    Boolean(token) &&
    userState.isLoggedIn &&
    userState.profileFetchStatus === "succeeded";
  const affiliateSessionOk =
    Boolean(affiliateToken) &&
    affiliateState.isLoggedIn &&
    affiliateState.profileFetchStatus === "succeeded";

  // Handle mobile menu click
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = (event) => {
    if (affiliateSessionOk) {
      setProfileKind("affiliate");
      setProfileModal(event.currentTarget);
      return;
    }
    if (studentSessionOk) {
      setProfileKind("student");
      setProfileModal(event.currentTarget);
      return;
    }
    if (
      (affiliateToken && affiliateState.profileFetchStatus === "loading") ||
      (token && userState.profileFetchStatus === "loading")
    ) {
      Toastify.info("Checking your session…");
      return;
    }
    navigate("/login");
  };

  const handleProfileClose = () => {
    setProfileModal(null);
    setProfileKind(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const openProfile = Boolean(profileModal);
  const profileId = openProfile ? "simple-popover" : undefined;

  useEffect(() => {
    setPath(pathname);
  }, [pathname]);

  useEffect(() => {
    if (affiliateToken) {
      dispatch(AffiliategetProfile());
    }
    if (token) {
      dispatch(getProfile());
    }
  }, [affiliateToken, token, dispatch]);

  useEffect(() => {
    if (userState?.data?._id) {
      dispatch(getNotification(userState.data._id));
    }
  }, [userState?.data?._id, dispatch]);

  const logout = async () => {
    try {
      const hadStudent = Boolean(token);
      const hadAffiliate = Boolean(affiliateToken);
      localStorage.removeItem("token");
      localStorage.removeItem("affiliatetoken");
      dispatch(setLogOut());
      dispatch(affiliateSetLogOut());
      handleProfileClose();
      Toastify.success("Logged out successfully");

      setTimeout(() => {
        if (hadStudent) {
          navigate("/courses/Courses");
          window.location.reload();
        } else if (hadAffiliate) {
          navigate("/affiliate/login");
          window.location.reload();
        }
      }, 1500);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleProtectedNavigation = (route) => {
    if (!token && !affiliateToken) {
      navigate("/login");
      return;
    }
    if (affiliateToken && !token) {
      navigate("/affiliate/login");
      return;
    }
    navigate(route);
  };

  const profilePayload = userState.user;
  const affiliatePayload = affiliateState.affiliate;
  const displayName =
    profileKind === "affiliate"
      ? affiliatePayload?.user?.name || affiliatePayload?.name || "Affiliate"
      : profilePayload?.user?.name || profilePayload?.name || "Student";

  // Handle external navigation
  const handleExternalNavigation = (url) => {
    if (url.startsWith('http')) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  // Handle logo click
  const handleLogoClick = () => {
    window.open("https://kingster.edu.in", '_blank');
  };

  // Handle contact click
  const handleContactClick = () => {
    window.open("https://kingster.edu.in/contact-us/", '_blank');
  };

  // Navigation items for both desktop and mobile
  const navItems = [
    { path: "home", route: "https://kingster.edu.in", label: "Home", external: true },
    { path: "about", route: "https://kingster.edu.in/about-us/", label: "About", external: true },
    { path: "courses", route: "/courses/Courses", label: "Courses", external: false },
    { path: "webinar", route: "/webinar/webinar", label: "Webinars", external: false },
    // { path: "ancillaryService", route: "https://kingster.edu.in/ancillary/", label: "Ancillary Service", external: true },
    // { path: "industries", route: "/industries/Industries", label: "E-commerce business solution", external: false },
    // { path: "Affiliate", route: "/affiliate/affiliate", label: "Affiliate", external: false },
    // { path: "blogs", route: "/blogs/Blogs", label: "Blogs", external: false },
    // { route: "https://kingster.edu.in/ecommerce/", label: "Ecommerce 2.0", customClass: styles.cateStyle, external: true },
  ];

  return (
    <div className={styles.container}>
      {/* Desktop Header */}
      <div className={styles.mainHeader}>
        <img
          src="/assets/logo.png"
          style={{ cursor: "pointer" }}
          onClick={handleLogoClick}
          className={styles.logo}
          alt="Kingster Logo"
        />
        
        <div className={styles.headerStyle} style={{ marginLeft: 5 }}>
          <div className={`${styles.opened} ${styles.rightNav}`}>
            {navItems.map((item, index) => (
              <div
                key={index}
                onClick={() => handleExternalNavigation(item.route)}
                className={
                  item.path && path === item.path
                    ? `${styles.inActive} ${styles.active} ${styles.navmenu}`
                    : item.customClass || styles.inActive
                }
              >
                {item.label}
              </div>
            ))}
          </div>
          
          <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-blue-50 border border-blue-100 backdrop-blur-sm ml-3">
            <div className="w-10 h-10 rounded-full bg-blue-500 grid place-items-center">
              <ForwardArrowIcon className="w-4 h-4 text-white" />
            </div>
            <div
              onClick={handleContactClick}
              className={
                path === "contact"
                  ? "px-3 py-2 rounded-full bg-blue-500 text-white font-medium cursor-pointer text-sm"
                  : "px-3 py-2 rounded-full bg-white text-gray-700 border border-gray-200 cursor-pointer text-sm"
              }
            >
              Contact
            </div>
          </div>
        </div>

        {/* User Profile Section */}
        <div className={`${styles.opened} ${styles.userStyle}`}>
          <div className={styles.iconStyle} onClick={handleProfileClick}>
            <UserIcon />
          </div>
        </div>

        {/* Profile Popover */}
        <Popover
          id={profileId}
          open={openProfile}
          anchorEl={profileModal}
          onClose={handleProfileClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          style={{ borderRadius: 30 }}
        >
          <div className={styles.profileStyle}>
            {(profileKind === "affiliate"
              ? affiliatePayload?.user?.profileImg?.length > 0
              : profilePayload?.user?.profileImg?.length > 0) ? (
              <img
                src={
                  profileKind === "affiliate"
                    ? affiliatePayload?.user?.profileImg?.[0]
                    : profilePayload?.user?.profileImg?.[0]
                }
                style={{ width: 40, height: 40, borderRadius: 20 }}
                alt="Avatar"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://www.svgrepo.com/show/486506/user-profile-filled.svg";
                }}
              />
            ) : (
              <img
                src="https://www.svgrepo.com/show/486506/user-profile-filled.svg"
                alt="User Avatar"
                className={styles.profileAvatar}
              />
            )}

            <div>
              <p className={styles.profileName}>{displayName}</p>
              <p className={styles.student}>
                {profileKind === "affiliate" ? "Affiliate" : "Student"}
              </p>
            </div>
          </div>
          
          {profileKind === "student" && (
            <>
              <div className={styles.bottomLine} />
              <div
                onClick={() => {
                  handleProfileClose();
                  navigate("/studentDashboard/StudentDashboard");
                }}
                className={styles.myProfile}
                style={{ marginBottom: 10 }}
              >
                My Profile
              </div>
            </>
          )}
          
          <div className={styles.bottomLine} />
          <div
            onClick={logout}
            className={styles.myProfile}
            style={{ marginBottom: 10 }}
          >
            Logout
          </div>
        </Popover>
      </div>

      {/* Mobile Header */}
      <div className={styles.mobilenav}>
        <img
          src="/assets/logo.png"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
          className={styles.logo}
          alt="Kingster Logo"
        />
        <div>
          <div onClick={handleClick} variant="contained">
            <HideMenuIcon />
          </div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{ width: "100%" }}
            style={{ borderRadius: 30 }}
          >
            <div style={{ padding: 15 }}>
              {[
                ...navItems,
                { path: "contact", route: "https://kingster.edu.in/contact-us/", label: "Contact", external: true },
                ...(studentSessionOk ? [{ path: "studentDashboard", route: "/studentDashboard/StudentDashboard", label: "My Profile", external: false }] : []),
              ].map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    handleClose();
                    if (item.external) {
                      handleExternalNavigation(item.route);
                    } else {
                      navigate(item.route);
                    }
                  }}
                  className={
                    item.path && path === item.path
                      ? `${styles.inActive} ${styles.active} ${styles.navmenu}`
                      : item.customClass || styles.inActive
                  }
                  style={{
                    marginBottom: 10,
                    marginTop: index > 0 ? 10 : 0,
                  }}
                >
                  {item.label}
                </div>
              ))}
              
              {(studentSessionOk || affiliateSessionOk) && (
                <>
                  <div className={styles.bottomLine} style={{ margin: '15px 0' }} />
                  <div
                    onClick={() => {
                      handleClose();
                      logout();
                    }}
                    className={styles.inActive}
                    style={{
                      marginBottom: 10,
                      color: '#ff4444',
                      fontWeight: 'bold',
                      cursor: 'pointer'
                    }}
                  >
                    Logout
                  </div>
                </>
              )}
            </div>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default Header;